interface Question {
  id: string;
  prompt: string;
  answer: string | string[] | boolean;
}

interface ApplicantQAProps {
  questions: Question[];
  layout?: 'compact' | 'spacious';
}

function formatAnswer(answer: string | string[] | boolean): string {
  if (typeof answer === 'boolean') {
    return answer ? 'Yes' : 'No';
  }
  if (Array.isArray(answer)) {
    return answer.join(' • ');
  }
  return answer;
}

export default function ApplicantQA({ questions, layout = 'compact' }: ApplicantQAProps) {
  if (layout === 'spacious') {
    return (
      <div className="space-y-4">
        <h2 className="text-sm font-bold text-gray-500 uppercase tracking-wide">
          Application Responses
        </h2>
        {questions.map((qa) => (
          <div key={qa.id} className="bg-white border border-gray-200 rounded-xl p-4">
            <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-2">
              {qa.prompt}
            </p>
            <p className="text-base text-gray-900 leading-relaxed">
              {formatAnswer(qa.answer)}
            </p>
          </div>
        ))}
      </div>
    );
  }

  // Compact layout (no borders)
  return (
    <div className="space-y-0">
      {questions.map((qa, idx) => (
        <div
          key={qa.id}
          className={`py-4 ${idx < questions.length - 1 ? 'border-b border-gray-100' : ''}`}
        >
          <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-1">
            {qa.prompt}
          </p>
          <p className="text-base text-gray-900 leading-relaxed">
            {formatAnswer(qa.answer)}
          </p>
        </div>
      ))}
    </div>
  );
}

